import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { DegerlendirmeEditComponent } from './degerlendirme-edit.component';
import { DegerlendirmeKartComponent } from './degerlendirme-kart.component';

@DinamikBilesen({
  id: 'degerlendirme',
  baslik: 'Değerlendirme',
  aciklama: 'Tedarikçi değerlendirmesi ekle',
  ikon: 'star',
  kategori: 'tedarikci',
})
class Degerlendirme {
  paylas_kutusu = DegerlendirmeEditComponent;
  paylasilmis_kart = DegerlendirmeKartComponent;
}
